import React from 'react';
import ChallengePopup from '../../challenges/challengePopup/challengePopup';
import canSendChallenge from '../../../helpers/canSendChallenge';
import { container } from 'tsyringe';
import { t } from '@base/utils/helpers';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function ChallengeOverlay(props: {
  opponent: { userName: string; avatar?: string; id: string };
  myRank?: number;
}) {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');

  return canSendChallenge({
    rank: props.myRank,
    uid: playersOnlineRepository.me?.userId,
  }) ? (
    <ChallengePopup
      name={props.opponent.userName}
      avatar={props.opponent.avatar}
      userId={props.opponent.id}
    />
  ) : (
    <span>{t('challenges_available_top_20_only')}</span>
  );
}
